import { HeatMechanicalResult } from "../../models/HeatMechanicalResult";
import {
	formatMechanicalValue,
	formatRange,
	mechanicalFailDetail,
} from "./format";
import { MechanicalResultValues } from "./types";

type ValueColumn = {
	field: keyof MechanicalResultValues;
	label: string;
	passed: (result: HeatMechanicalResult) => boolean | null;
	format: (result: HeatMechanicalResult) => string | number;
	range: (result: HeatMechanicalResult) => string;
	/** Violated limit ("Min: X" / "Max: X") — tooltip on failed values. */
	failDetail: (result: HeatMechanicalResult) => string | null;
};

export const VALUE_COLUMNS: ValueColumn[] = [
	{
		field: "yieldValue",
		label: "Yield",
		passed: (r) => r.YieldPassed,
		format: (r) =>
			formatMechanicalValue(
				r.YieldValue,
				r.YieldPassed,
				r.YieldMin,
				r.YieldMax,
				3,
				r.YieldMinKsi,
				r.YieldMaxKsi,
			),
		range: (r) => formatRange(r.YieldMin, r.YieldMax, r.Unit?.trim() || null),
		failDetail: (r) =>
			mechanicalFailDetail(
				r.YieldValue,
				r.YieldMin,
				r.YieldMax,
				r.YieldMinKsi,
				r.YieldMaxKsi,
			),
	},
	{
		field: "tensileValue",
		label: "Tensile",
		passed: (r) => r.TensilePassed,
		format: (r) =>
			formatMechanicalValue(
				r.TensileValue,
				r.TensilePassed,
				r.TensileMin,
				r.TensileMax,
				3,
				r.TensileMinKsi,
				r.TensileMaxKsi,
			),
		range: (r) =>
			formatRange(r.TensileMin, r.TensileMax, r.Unit?.trim() || null),
		failDetail: (r) =>
			mechanicalFailDetail(
				r.TensileValue,
				r.TensileMin,
				r.TensileMax,
				r.TensileMinKsi,
				r.TensileMaxKsi,
			),
	},
	{
		field: "elongationValue",
		label: "Elong.",
		passed: (r) => r.ElongationPassed,
		format: (r) =>
			formatMechanicalValue(
				r.ElongationValue,
				r.ElongationPassed,
				r.ElongationPercentMin,
				null,
			),
		range: (r) => formatRange(r.ElongationPercentMin, null, "%"),
		failDetail: (r) =>
			mechanicalFailDetail(r.ElongationValue, r.ElongationPercentMin, null),
	},
	{
		field: "percentRAValue",
		label: "% RA",
		passed: (r) => r.PercentRAPassed,
		format: (r) =>
			formatMechanicalValue(
				r.PercentRAValue,
				r.PercentRAPassed,
				r.PercentRAMin,
				r.PercentRAMax,
			),
		range: (r) => formatRange(r.PercentRAMin, r.PercentRAMax, "%"),
		failDetail: (r) =>
			mechanicalFailDetail(r.PercentRAValue, r.PercentRAMin, r.PercentRAMax),
	},
];

// Header/footer styled after the AG Grid material theme used everywhere else
// (see setup/ag-grid.ts): bold header on white, status-bar-like footer.
export const headerCellSx = {
	fontWeight: 600,
	color: "#0008",
	top: 0,
	height: 30,
	py: 0.25,
	bgcolor: "#fff",
	borderBottom: "1px solid #e0e0e0",
};

export const refCellSx = {
	position: "sticky" as const,
	bottom: 0,
	zIndex: 2,
	fontWeight: 600,
	color: "text.secondary",
	height: 28,
	py: 0.25,
	bgcolor: "#f5f5f5",
	borderTop: "1px solid #ccc",
	borderBottom: 0,
	whiteSpace: "nowrap",
};
